/**
 * Médias de la page Support & Aide (Formation).
 *
 * ====> C'EST ICI QUE VOUS REMPLISSEZ LES LIENS <====
 *
 *  - poster : image d'aperçu affichée avant lecture.
 *             Fichier dans  src/ressources/images/formation/  (importé ci-dessus).
 *             Pour changer l'image, remplacez le fichier .png du même nom.
 *  - video  : lien de la vidéo. Fichier local -> public/videos/xxx.mp4
 *             (chemin commençant par « / »), ou URL externe (https://...).
 *             Laissez '' si la vidéo n'est pas encore disponible :
 *             la carte affichera l'aperçu mais ne sera pas cliquable.
 *
 * Le `title` est la clé de traduction (voir dictionnaire_aide.js).
 */
import posterAccueil from '../../ressources/images/formation/accueil.png';
import posterPlans from '../../ressources/images/formation/plans.png';
import posterGraphes from '../../ressources/images/formation/graphes.png';
import posterTableaux from '../../ressources/images/formation/tableaux.png';

export const FORMATION_VIDEOS = [
  {
    key: 'accueil',
    title: 'Naviguez dans votre page d’accueil',
    poster: posterAccueil,
    video: 'https://argos-v19.itmsol.fr/videos/Homepage.mp4',
  },
  {
    key: 'plans',
    title: 'Afficher vos plans',
    poster: posterPlans,
    video: 'https://argos-v19.itmsol.fr/videos/Plans.mp4',
  },
  {
    key: 'graphes',
    title: 'Afficher vos graphes',
    poster: posterGraphes,
    video: 'https://argos-v19.itmsol.fr/videos/Graphes.mp4',
  },
  {
    key: 'tableaux',
    title: 'Afficher vos tableaux de bord',
    poster: posterTableaux,
    video: 'https://argos-v19.itmsol.fr/videos/Tableaux de bord.mp4',
  },
];

/**
 * Guides PDF téléchargeables (boutons « Version FR / PT »).
 * Remplacez `pdf` par le lien du guide quand il sera prêt.
 * Fichier local -> public/pdf/xxx.pdf  (chemin commençant par « / »).
 * Le `label` est la clé de traduction.
 */
export const FORMATION_GUIDES = [
  { key: 'fr', label: 'Version FR', pdf: 'https://argos-v19.itmsol.fr/pdf/utilisation.pdf' },
  { key: 'pt', label: 'Version PT', pdf: 'https://argos-v19.itmsol.fr/pdf/utilisation-pt.pdf' }
];
